export function noop() { }

export function pick(obj, keys) {
  const newObj = {};
  keys.forEach((key) => {
    newObj[key] = obj[key];
  });
  return newObj;
}

export function getNamespace(WrapperComponent, WrapperComponentInstance) {
  if (typeof WrapperComponent.sessionStorageNamespace === 'string') {
    return WrapperComponent.sessionStorageNamespace;
  } else if (typeof WrapperComponent.sessionStorageNamespace === 'function') {
    return WrapperComponent.sessionStorageNamespace(WrapperComponentInstance.props, WrapperComponentInstance.state);
  }

  console.error('Namespace is missing for the wrapped component. Make sure your component has sessionStorageNamespace present.');
}
